import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import Destination from '../../../models/Destination';
import Location from '../../../models/Location';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'shelf-container',
  templateUrl: './shelf.component.html',
  styleUrls: ['./shelf.component.scss']
})
export class ShelfComponent implements OnChanges {
  navigationSubscription: Subscription;
  @Input() destinationObj?: Destination;

  @Input() selectedDestination?: Destination;
  @Input() selectedLocation?: Location;

  public runEmit = true;

  @Output() onDrop = new EventEmitter<any>();
  drop(data: any) {
    if (this.runEmit) {
      this.onDrop.emit(data);
    }
    if (data instanceof Location) {
      this.runEmit = false;
    } else {
      this.runEmit = true;
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes['destinationObj'] !== 'undefined') {
      this.destinationObj = (changes as any)['destinationObj'].currentValue;
    }
    if (typeof changes['selectedDestination'] !== 'undefined') {
      this.selectedDestination = (changes as any)['selectedDestination'].currentValue;
    }
    if (typeof changes['selectedLocation'] !== 'undefined') {
      this.selectedLocation = (changes as any)['selectedLocation'].currentValue;
    }
  }
}
